module.exports = __webpack_public_path__ + "static/media/close.2a051700.svg";